import React, { FC, memo } from "react";
import Banner from "@modules/Layout/components/CoverBannerCrop";
import useProductCategoryPageAttr from "../hooks/useProductCategoryPageAttr";

const Cover: FC = () => {
  const { data: result } = useProductCategoryPageAttr();
  const { banner } = result!.data.attributes;
  return <Banner banner={banner} typeImage={"cover"} bg={"transparent"} />;
};

export default memo(Cover);
